import React from "react";
import styled from "styled-components";
import { FormattedHTMLMessage } from "react-intl";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import messages from "./messages";
import LogoSvg from "./Annexus_Logo.svg";

const StyledAppBar = styled(AppBar)`
  background-color: #eef2f4 !important;
  box-shadow: none !important;
`;

const StyledTypography = styled(Typography)`
  font-size: 24px !important;
  color: #285c75;
  font-family: "Lato-Light" !important;
  display: inline;
  position: relative;
  top: -25px;
  left: 15px;
  padding: 10px 0px 10px 20px;
  border-left: 1px solid #cccccc;
  @media only screen and (max-width: 768px) {
    font-size: 20px !important;
    display: block;
    padding: 0;
    border: none;
    top: -10px;
    left: 0;
  }
`;

const StyledToolbar = styled(Toolbar)`
  padding: 0 !important;
`;

const StyledImage = styled.img`
  max-width: 245px;
  display: inline;
  padding: 15px 5px 5px 0px;
  @media only screen and (max-width: 768px) {
    max-width: 190px;
  }
`;
const Header = () => {
  return (
    <React.Fragment>
      <StyledAppBar position="static">
        <StyledToolbar>
          <Grid container spacing={0} justify="center">
            <Grid item xs={11} sm={10} md={8} lg={9} xl={7}>
              <a href="/">
                <StyledImage src={LogoSvg} />
              </a>
              <StyledTypography variant="h6">
                <FormattedHTMLMessage {...messages.title} />
              </StyledTypography>
            </Grid>
          </Grid>
        </StyledToolbar>
      </StyledAppBar>
    </React.Fragment>
  );
};

export default Header;
